<template>
	<main class="clients-area">
        <wait-modal ref="waitModal" :title="translation"/>
        <invalid-modal ref="invalidModal"/>

		<div class="clients-area__inner new-layout-container">
			<header v-if="hasAccess" class="clients-area__header">
				<div class="clients-area__title">
					<span aria-hidden="true"></span>
					<h1>{{translation}}</h1>
				</div>
				<a class="clients-area__exit" href="/calendar">{{exitLabel}}</a>
			</header>

			<clients-area-bookings v-if="hasAccess" :files="clientFiles"/>
			<clients-area-login v-else @validateLogin="validateLogin"/>
		</div>
	</main>
</template>
<script>
import { translate } from '../../assets/translations';
import ClientsAreaLogin from './ClientsAreaLogin.vue';
import ClientsAreaBookings from './ClientsAreaBookings.vue';
import BookingService from '../../services/BookingService';
import WaitModal from '../shared/WaitModal.vue';
import InvalidModal from '../shared/InvalidModal.vue';
export default {
    computed: {
        translation() {
            return translate(this.$store.state.language).navbar.clientsArea;
        },
		exitLabel() {
			return translate(this.$store.state.language).navbar.exit;
		},
        translationErrorMessage() {
            return translate(this.$store.state.language).conclusionErroClientFiles;
        }
    },
    data() {
        return {
            bookingService: null,
            clientFiles: [],
            hasAccess: false
        };
    },
    mounted() {
        this.validateLogin(this.$store.state.event);
    },
    methods: {
        validateLogin(event) {
            this.hasAccess = event && event.statusLogin;
            if(!this.hasAccess)
                return;
            this.bookingService = new BookingService(event.client);
            let hasError = false;
            this.$refs.waitModal.open();
            this.bookingService.getFiles().then(res => {
			    let allFiles = res.data.files;
                allFiles.sort((a,b)=> {
                    let dateA = new Date(a.creationDate.split('/').reverse().join('/'));
                    let dateB = new Date(b.creationDate.split('/').reverse().join('/'));
                    return dateB - dateA;
                });
                this.clientFiles = allFiles;
		    }).catch(()=>{
                hasError = true;
            }).finally(()=>{
                this.$refs.waitModal.close();
                if(hasError)
                    this.$refs.invalidModal.open(this.translationErrorMessage.title, this.translationErrorMessage.message);
            });
        }
    },
    components: { ClientsAreaLogin, ClientsAreaBookings, WaitModal,InvalidModal }
}
</script>
<style scoped lang="scss">
.clients-area {
	box-sizing: border-box;
	min-height: 520px;
	padding: 70px 0 110px;
	background: #f5f5f5;
	color: #5a5a5a;
}

.clients-area__inner {
	padding: 0;
}

.clients-area__header {
	display: flex;
	align-items: flex-end;
	justify-content: space-between;
	gap: 24px;
	margin-bottom: 35px;
}

.clients-area__title span {
	display: block;
	width: 44px;
	margin-bottom: 18px;
	border-top: 4px solid #e89127;
}

.clients-area__title h1 {
	margin: 0;
	color: #002c41;
	font-size: 32px;
	font-weight: 700;
	line-height: 38px;
}

.clients-area__exit {
	display: inline-flex;
	align-items: center;
	justify-content: center;
	box-sizing: border-box;
	min-width: 120px;
	height: 40px;
	padding: 0 24px;
	border: 1px solid #e89127;
	border-radius: 10px;
	background: #ffffff;
	color: #e89127;
	font-size: 16px;
	font-weight: 700;
	line-height: 19px;
	text-decoration: none;
}

.clients-area__exit:hover,
.clients-area__exit:focus-visible {
	background: #e89127;
	color: #ffffff;
}

@media (max-width: 600px) {
	.clients-area {
		padding: 42px 0 72px;
	}

	.clients-area__header {
		align-items: flex-start;
		flex-direction: column;
	}

	.clients-area__title h1 {
		font-size: 26px;
		line-height: 32px;
	}

	.clients-area__exit {
		width: 100%;
	}
}
</style>



// WEBPACK FOOTER //
// src/components/clients-area/ClientsArea.vue